import { render, staticRenderFns } from "./MonitTabItem.vue?vue&type=template&id=087d03c6&scoped=true&"
import script from "./MonitTabItem.vue?vue&type=script&lang=js&"
export * from "./MonitTabItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087d03c6",
  null
  
)

export default component.exports